/**
 * «Recordar sesión en este equipo» (ingreso rediseñado, 25-oct).
 *
 * La sesión vive en localStorage, que sobrevive a cerrar el navegador. Cuando
 * la persona NO marca la casilla, al ingresar se anotan dos cosas:
 *   - en localStorage, que esta sesión no se recuerda;
 *   - una cookie SIN vencimiento: el navegador la borra al cerrarse, y la
 *     comparten todas las pestañas (sessionStorage no: una pestaña nueva
 *     cerraría la sesión de todas).
 *
 * Al arrancar la app, si la sesión no se recuerda y la cookie ya no está, el
 * navegador se cerró desde el ingreso: se cierra la sesión.
 */

const CLAVE = 'prixia-recordar-sesion';
const COOKIE = 'prixia_sesion_abierta';

/** Se llama al ingresar, antes de recargar la página. */
export function anotarRecordarSesion(recordar: boolean): void {
  try {
    if (recordar) {
      window.localStorage.removeItem(CLAVE);
      document.cookie = `${COOKIE}=; path=/; max-age=0; SameSite=Lax`;
    } else {
      window.localStorage.setItem(CLAVE, 'no');
      document.cookie = `${COOKIE}=1; path=/; SameSite=Lax`;
    }
  } catch {
    // Sin almacenamiento disponible no hay nada que recordar ni que olvidar.
  }
}

/** ¿El navegador se cerró desde un ingreso que no pidió ser recordado? */
export function sesionVencidaAlCerrarElNavegador(): boolean {
  try {
    if (window.localStorage.getItem(CLAVE) !== 'no') return false;
    return !document.cookie.split('; ').some((c) => c === `${COOKIE}=1`);
  } catch {
    return false;
  }
}
